import React from 'react'
import MusicCard from './MusicCard'
import AlbumCard from './AlbumCard'
import './Home.css'
import Sacred from './img/Mockup_Sacred.png'
import Infinite from './img/Mockup_Infinite.png'
import Placeholder from './img/Mockup_Placeholder.png'
import Reverence from './img/Mockup_Reverence.png'
import SomethingMore from './img/Mockup_Somethingmore.png'
import InfiniteR from './img/Mockup_InfiniteR.png'


function Home() {
    return (
        <div className='home' >
            <div className="home_intro">
                <h2>Home</h2>
                <p>Hi! Welcome to my personal website where I upload my music tracks! This is currently a test used solely for demonstration purposes
                    (or perhaps if I ever make it big I can use this as my template)
                    <br/><br/>
                    Feel free to explore. This site demonstrates various ReactJS features and imports.
                    <br/><br/>
                    The site is hosted on Google firebase, a web hosting service.

                    Inquiries: kamerond1899@gmail.com
                </p>
                
            <a href='https://soundcloud.com/blooflazh'>                
                <img className='linkicon' src='https://cdn2.iconfinder.com/data/icons/minimalism/512/soundcloud.png'/>
            </a>

            <a href='https://www.youtube.com/channel/UCrVWNo93Pafoug1_n5EF9VA'>
                <img className='linkicon' src='https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/2560px-YouTube_full-color_icon_%282017%29.svg.png'/>
            </a>
            <a href='https://www.linkedin.com/in/kdangleben/'>
                <img className='linkicon' src='https://cdn-icons-png.flaticon.com/512/61/61109.png'/>
            </a>

            <a href='https://github.com/kamerond1899'>
                <img className='linkicon' src='https://cdn-icons-png.flaticon.com/512/25/25231.png'/>
            </a>
            <a href='https://open.spotify.com/artist/2bXv1kmGXiELGMrX2DoLW6?si=wWv-ZJ2uRQeL2nfPRdhGYw'>
                <img className='linkicon' src='https://cdn-icons-png.flaticon.com/512/174/174872.png'/>
            </a>
            
            </div>
            <div className='home_music'>

            </div>
            <AlbumCard image={Reverence} title="Reverence"
            release="July 2022" description="First EP out now on Spotify!" release_link={"https://open.spotify.com/album/4tTwPJhF2IRuFoAJ1lR6mb?si=GcqAzM71RKOY0I6KKyDVlw"} onsoundcloud sclink={"https://soundcloud.com/blooflazh/reverence?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"}/>

        <AlbumCard image={InfiniteR} title="Infinite Realities"
            release="TBD" description="Coming to Spotify August 2022!"  unreleased onsoundcloud sclink={"https://soundcloud.com/blooflazh/infinite-realities?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"}/>

            <AlbumCard image={Sacred} title="Sacred Geometry"
            release="March 2022" description="First Spotify Single" release_link={"https://open.spotify.com/track/7qadvEcUAqmYBrkcfZxGNR?si=8cebaedaeff4409b"}/>

                 <AlbumCard image={SomethingMore} title="Something More (Rough cut)"
            release="March 2022" description="Pre-Spotify Tracks from 2020-2022 all released on Spotify as a compilation. Will be re released in the future." release_link={"https://open.spotify.com/album/4ENYAj1MXspd1UGbeNQAc1?si=XNFiyg-ERpeXzBzfFmluBA"}/>


        </div>
        
    )
}

export default Home
